<template>
  <tbody style="cursor: pointer">
    <v-menu
      v-model="menu[booking.id.toString()]"
      offset-y
      max-width="200"
      nudge-right="100"
      lazy
      :close-on-content-click="false"
      :disabled="embedded"
    >
      <template v-slot:activator="{ on }">
        <tr
          v-if="targetBooking && targetBooking.id == booking.id"
          style="width: 100%; height: 4px; background-color: red;"
        >
          <td  />
          <td />
          <td />
          <td />
          <td />
          <td />
        </tr>
        <tr
          :style="styleForUpcomingBookingRow(booking)"
          valign="top"
          @click="setSelectedBooking(booking.id, -1)"
          v-on="on"
        >
          <td style="text-align: left !important;" v-html="numPeople(booking)" />
          <td>{{ timeForBooking(booking.pickup_time, false) }}</td>
          <td>{{ booking.pickup_time.substring(0, 10) }}</td>
          <td>
            <div class="fixed-table-row">
              {{ prettify(booking.pickup_location.description) }}
            </div>
          </td>
          <td>
            <ViasForBooking :booking="booking" />
          </td>
          <td>
            <div class="fixed-table-row">
              {{ destinationForBooking(booking) }}
            </div>
          </td>
          <td v-if="!expanded">
            <div class="fixed-table-row-truncate">
              {{ nameOrRoomForCustomerForBooking(booking) }}
            </div>
          </td>
          <td v-if="!expanded">
            <AttributesForBookingCell :booking="booking" />
          </td>
        </tr>
      </template>
      <BookingMenu
        :booking="booking"
        @copy="copy(booking)"
        @edit="edit(booking.id)"
        @assign="assign(booking.id)"
        @close="menu[booking.id.toString()] = false"
        @track="setSelectedBooking(booking.id, -1)"
      />
    </v-menu>
  </tbody>
</template>

<script>
import BookingMenu from "@/components/widget/menu/BookingMenu.vue";
import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";
import TableSearch from "@/components/overwatch/TableSearch.vue";

import moment from "moment";
import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

import { Overwatch } from "@/components/util/Overwatch.js";

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "UnconfirmedBookingTableRows",
  components: {
    AttributesForBookingCell,
    TableSearch,
    BookingMenu,
    ViasForBooking,
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    targetBooking: {
      type: Object,
      default: null
    },
    expanded: {
      type: Boolean,
      default: false
    },
    lastBookingId: {
      type: Number,
      default: null
    },
    selectedDateTime: String,
    booking: Object,
    taxis: Array,
    bookings: Array,
    setSelectedBooking: Function,
    selectedBooking: Number,
    showAssign: Function,
    hoursToShow: Number,
    pagination: Object,
    embedded: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: {},
      options: { itemsPerPage: 50, page: null },
    };
  },
  computed: {
    isRedLine () {
      return moment(this.selectedDateTime).isBefore(moment(this.booking.pickup_time))
    }
  },
  watch: {
    bookings: function () {
      // console.log("Bookings search");
      try {
        this.$refs.tableSearch.searchTable();
      } catch (e) {}
    },
  },
  methods: {
    numPeople: function(booking) {
      if (booking.num_people > 4) {
        return '<div class="circle">' + booking.num_people + "</div>"
      } else {
        return '<div class="center">' + booking.num_people + "</div>";
      }
    },
    paymentTypeForBooking: function(booking) {
      if (booking.payment_type == 'card') {
        if (booking.card_payment_type != null && booking.card_payment_type == "prepaid") {
          return "paid";
        } else {
          return "card";
        }
      } else if (booking.payment_type == 'account') {
        return "acc";
      } else if (booking.payment_type == 'card_in_cab') {
        return "cic";
      } else if (booking.payment_type == 'cash') {
        return "cash";
      }
    },
    costForBooking: function(booking) {
      var cost = 0;

      if (booking.final_cost_promotion != null && booking.final_cost_promotion != 0) {
        cost = booking.final_cost_promotion;
      } else if (booking.final_cost != null && booking.final_cost != 0) {
        cost = booking.final_cost;
      } else if (booking.estimated_cost_promotion != null &&  booking.estimated_cost_promotion != 0) {
        cost = booking.estimated_cost_promotion;
      } else if (booking.estimated_cost != null && booking.estimated_cost != 0) {
        cost = booking.estimated_cost;
      }

      if (cost == 0) {
        return "";
      }

      return (cost / 100.0).toFixed(2)
    },
    updateOptions: function (e) {
      console.log(e);
      this.$emit("changePage", e.page);
    },
      nameOrRoomForCustomerForBooking: function (b) {
      
      if (b.room_number != null && b.room_number != "" && b.business_customer_name != null && b.business_customer_name != "") {
        return b.room_number + " - " + b.business_customer_name.substring(0, Math.min(5, b.business_customer_name.length));  
      } else if (b.business_customer_name != null && b.business_customer_name != "") {
        return b.business_customer_name;
      } else if (b.room_number != null && b.room_number != "") {
        return b.room_number + " - " + b.customer_name.substring(0, Math.min(5, b.customer_name.length));
      } else {
        return b.customer_name;
      }
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    hoursToShowChanged: function () {
      this.$emit("changeHoursToShow", Number(this.hoursToShow));
    },
    copy: function (booking) {
      this.$emit("copy", booking);
    },
    edit: function (bookingID) {
      this.$emit("edit", bookingID);
    },
    assign: function (bookingID) {
      this.$emit("assign", bookingID);
    },
    preassignedDriver: function (booking) {
      try {
        if (booking.preassigned_driver != null) {
          var preassignedString = "";
          if (
            !new Overwatch(this.taxis, this.bookings).driverIsOnline(
              booking.preassigned_driver.driver.id
            )
          ) {
            preassignedString +=
              "<div style='padding-top: 2px; background-color: #dadada; border-radius: 8px;'><p align='center'>";
          } else {
            preassignedString +=
              "<div style='padding-top: 2px; background-color: white; border-radius: 8px;'><p align='center'>";
          }

          preassignedString += "<b>";

          if (booking.preassigned_driver.assignment_type == "assignment_type_bid") {
            preassignedString += "b"
          }

          preassignedString += booking.preassigned_driver.driver.callsign
            
          preassignedString += "</b>";

          preassignedString += "</a></div>";
          return preassignedString;
        } else {
          return "";
        }
      } catch (e) {
        console.log(e);
      }
    },
    preassignedDriverName: function (booking) {
      if (booking.preassigned_driver != null) {
        return booking.preassigned_driver.driver.name;
      } else {
        return "";
      }
    },
    offeredTaxiForBooking: function (booking) {
      var taxiID = null;

      if (
        booking.has_follow_on_offer &&
        booking.follow_on_job_offer_taxis != null
      ) {
        // get follow on taxis for booking
        taxiID = booking.follow_on_job_offer_taxis;
      } else if (booking.offer_taxis != null) {
        taxiID = booking.offer_taxis;
      }

      if (taxiID != null) {
        var taxi = this.taxis.find(function (t) {
          return t.id == taxiID;
        });

        if (taxi != null) {
          return taxi.driver.callsign;
        }
      }

      return "";
    },
    styleForUpcomingBookingRow: function (booking) {
      // if being offered return
      var color = "white";
  
      if (booking.state == 'unconfirmed') {
        color = this.$colorsConfig.getUnconfirmedBookingColor()
        var style = {
          "background-color": color,
        };
        return style
      }
  
      console.log(booking.priority);

      if (booking.taxi) {
        color = "#6cffbb";
      } else if (booking.has_follow_on_offer) {
        color = "#6cffbb";
      } else {
        if (booking.asap || booking.estimated_dispatch_timestamp == null) {
          dispatchTimeMillis = booking.pickup_timestamp;
        } else {
          dispatchTimeMillis = booking.estimated_dispatch_timestamp;
        }

        var now = moment(new Date());
        var end = moment(dispatchTimeMillis);

        var dispatchTimeMillis = 0;

        var lateString = "";

        var diff = now.diff(end);

        var duration = moment.duration(diff);

        var minutes = duration.asMinutes();

        // console.log(minutes);

        // 10 minute threshold for running late
        if (booking.asap && minutes >= 9.5) {
          color = "#ff6c6c";
        } else if (!booking.asap && minutes >= -10) {
          color = "#fcbd68";
        }
      }

      var style = {
        "background-color": color,
      };

      if (this.selectedBooking == booking.id) {
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.15)";
      }

      return style;
    },
    timeForBooking: function (timeString) {
      var time = moment(timeString, "DD/MM/YYYY HH:mm");

      return `${time.format("HH:mm")}`;
    },
    dispatchTimeForBooking: function (booking) {
      if (booking.asap) {
        return "<b class='blink_me' style='color: red'>ASAP</b>";
      }

      var dispatchTimeMillis = 0;
      dispatchTimeMillis = booking.pickup_timestamp;

      var now = moment(new Date());
      var end = moment(dispatchTimeMillis);

      // console.log(now);
      // console.log(end);

      var lateString = "";

      if (now.isAfter(end)) {
        // lateString = " ago";
      }

      var diff = now.diff(end);

      var duration = moment.duration(diff);

      var lateTimeString = this.durationToHoursMinutesString(duration, "m");

      if (!end.isSame(new Date(), "day") && !now.isAfter(end)) {
        lateTimeString = end.format("DD/MM");
      }

      return lateTimeString + lateString;
    },
    durationToHoursMinutesString: function (duration, minutesString) {
      return Overwatch.durationToHoursMinutesString(duration, minutesString);
    },
    secondsToHoursMinutesString: function (seconds) {
      var duration = moment.duration(seconds, "seconds");

      var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

      return hoursMinutesString;
    },
    prettify: function (d) {
      return Overwatch.prettifyAddress(d);
    },
    viasForBooking: function (b) {
      return Overwatch.viasForBooking(b);
    },
    destinationForBooking: function (b) {
      return Overwatch.destinationForBooking(b);
    },
    sortUpcomingBookings: function (a, b) {
 

      var dispatchTimeA = 0;
      var dispatchTimeB = 0;

      if (a.asap) {
        dispatchTimeA = a.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeA = a.estimated_dispatch_timestamp;
        } else {
          dispatchTimeA = a.pickup_timestamp;
        }
      }

      if (b.asap) {
        dispatchTimeB = b.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeB = b.estimated_dispatch_timestamp;
        } else {
          dispatchTimeB = b.pickup_timestamp;
        }
      }
  
      if (a.priority) {
        return -1;
      } else if (b.priority) {
        return 1;
      }

      if (dispatchTimeA < dispatchTimeB) {
        return -1;
      } else if (dispatchTimeA > dispatchTimeB) {
        return 1;
      } else {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        } else {
          return 0;
        }
      }
      // }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#gridcontainer {
  position: absolute;
  top: 24px;
  bottom: 0px;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  top: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 8px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
}

th {
  text-align: left;
  color: #10425a;
}

th,
td {
  text-align: left;
  padding-left: 8px;
  padding-top: 1px;
}

tr {
  padding-top: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

// tr:nth-child(even) {
//   background-color: #f2f2f2;
// }

tbody:nth-child(even) {
  background-color: #f2f2f2;
}

.via-list {
  list-style: disc !important;
  padding-left: 14px !important;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}

.padding-li {
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 12px;
}

.padding-li:hover {
  background-color: #dedede;
}

.no-text-overflow {
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: none;
}

.blink_me {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.v-btn--icon.v-size--default {
  height: 24px !important;
  width: 24px !important;
}

.circle {
  width: 16px;
  height: 16px;
  line-height: 15px;
  border-radius: 50%;
  background: #FFBB96;
  text-align: center;
}

.center { width: 16px;
  height: 16px;
  text-align: center;
}
</style>
